// Simple CSS animations as fallback
export const addSimpleAnimations = () => {
  // Add CSS for basic animations
  const style = document.createElement('style');
  style.textContent = `
    .fade-in {
      animation: fadeIn 1s ease-out forwards;
      opacity: 0;
    }
    
    .slide-up {
      animation: slideUp 1s ease-out forwards;
      opacity: 0;
      transform: translateY(30px);
    }
    
    .scale-in {
      animation: scaleIn 0.8s ease-out forwards;
      opacity: 0;
      transform: scale(0.9);
    }
    
    @keyframes fadeIn {
      to {
        opacity: 1;
      }
    }
    
    @keyframes slideUp {
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    
    @keyframes scaleIn {
      to {
        opacity: 1;
        transform: scale(1);
      }
    }
    
    .hover-zoom {
      transition: transform 0.3s ease;
    }
    
    .hover-zoom:hover {
      transform: scale(1.05);
    }
  `;
  
  if (!document.head.querySelector('#simple-animations')) {
    style.id = 'simple-animations';
    document.head.appendChild(style);
  }
};

// Apply simple animations to elements
export const applySimpleAnimation = (element, animationType = 'fade-in') => {
  if (!element) return;
  
  // Add CSS animations
  addSimpleAnimations();
  
  // Add animation class
  element.classList.add(animationType);
};

// Intersection Observer for scroll animations
export const setupScrollAnimations = () => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fade-in');
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -100px 0px'
  });

  // Observe elements with scroll animation
  const elements = document.querySelectorAll('.scroll-animate');
  elements.forEach(el => observer.observe(el));
  
  return observer;
};